import { connect } from 'react-redux';

import { appModalClose } from 'actions';

import View from './';

const mapStateToProps = state => ({
  modals: state.app.modals,
});

const mapDispatchToProps = dispatch => ({
  appModalClose() {
    dispatch(appModalClose());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/components/modal/container.js